/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';


const MEDIAN_BAND = 2;

const LOWER_BANDS = 2;
const UPPER_BANDS = 3;


export default class ColonyValueBands extends Logic
{
  constructor (colony)
  {
    super(colony);

    const values = colony.getZones().values().map(zone => zone.cass.value).sort((lhs, rhs) => lhs - rhs);

    this.min = values[0];
    this.median = values[Math.floor((values.length - 1) / 2)];
    this.max = values[values.length - 1];
  }


  getBand (value)
  {
    if (value < this.median)
    {
      return Math.floor(LOWER_BANDS * (value - this.min) / (this.median - this.min));
    }

    if (value > this.median)
    {
      return MEDIAN_BAND + Math.ceil(UPPER_BANDS * (value - this.median) / (this.max - this.median));
    }

    return MEDIAN_BAND;
  }


};
